module.exports = __webpack_public_path__ + "img/news_list_2.5eaca1ef.jpg";